<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    selectLabel=""
    :custom-label="labelCustom"
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    labelCustom({ name }) {
      return `${name}`;
    },
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_categoria', null);
        return;
      }
      this.isObject
        ? this.$emit('selectChange', 'id_categoria', e)
        : this.$emit('selectChange', 'id_categoria', e.id);
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('category_nodin', {
          columns: 'id, name',
          order: 'name'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, name: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    }
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
